import React, { useState } from 'react';
import { ThumbsUpIcon } from 'lucide-react';
interface Comment {
  name: string;
  avatar: string;
  text: string;
  time: string;
  likes: number;
  replies?: Comment[];
}
export function TestimonialsSection() {
  const [showAll, setShowAll] = useState(false);
  const comments: Comment[] = [{
    name: 'Michael R.',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face',
    text: "Finished day 5. The Downshift technique alone is worth 10 times the price. I used it last night and for the first time in months I wasn't in my head the whole time.",
    time: '2d',
    likes: 47,
    replies: [{
      name: 'James K.',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face',
      text: 'Same here brother. Night and day difference.',
      time: '1d',
      likes: 12
    }, {
      name: 'David M.',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop&crop=face',
      text: 'The re-anchor part clicked for me on day 3. Game changer.',
      time: '1d',
      likes: 8
    }]
  }, {
    name: 'Robert T.',
    avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=80&h=80&fit=crop&crop=face',
    text: "56 years old, divorced 2 years ago. Started dating again and the anxiety was killing me. This guide gave me an actual SYSTEM instead of just 'relax bro'. My confidence is back.",
    time: '1w',
    likes: 89
  }, {
    name: 'Steve H.',
    avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=80&h=80&fit=crop&crop=face',
    text: "The part about reading her face like a verdict... felt like someone was reading my mind. Finally understand what's been happening.",
    time: '5d',
    likes: 34,
    replies: [{
      name: 'Paul W.',
      avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=80&h=80&fit=crop&crop=face',
      text: "That section hit different. So accurate it's scary.",
      time: '4d',
      likes: 15
    }]
  }, {
    name: 'Thomas B.',
    avatar: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=80&h=80&fit=crop&crop=face',
    text: 'Skeptical at first but the 90-second reset actually works. Wife noticed the difference immediately. Less rushing, more presence.',
    time: '3d',
    likes: 52
  }, {
    name: 'William C.',
    avatar: 'https://images.unsplash.com/photo-1504257432389-52343af06ae3?w=80&h=80&fit=crop&crop=face',
    text: "The Fail-Proof Ladder eliminated so much pressure. Even when things weren't perfect, I didn't panic. That's huge for me.",
    time: '6d',
    likes: 28,
    replies: [{
      name: 'Greg L.',
      avatar: 'https://images.unsplash.com/photo-1548372290-8d01b6c8e78c?w=80&h=80&fit=crop&crop=face',
      text: 'This. The ladder concept changed everything for me too.',
      time: '5d',
      likes: 9
    }]
  }, {
    name: 'Mark D.',
    avatar: 'https://images.unsplash.com/photo-1566492031773-4f4e44671857?w=80&h=80&fit=crop&crop=face',
    text: "I'm 58. Been dealing with this silently for years. This guide finally put words to what I was experiencing. The monitoring loop explanation alone was worth it.",
    time: '4d',
    likes: 63,
    replies: [{
      name: 'Alan R.',
      avatar: 'https://images.unsplash.com/photo-1552058544-f2b08422138a?w=80&h=80&fit=crop&crop=face',
      text: 'Exactly the same for me. Finally someone gets it.',
      time: '3d',
      likes: 11
    }]
  }, {
    name: 'Frank J.',
    avatar: 'https://images.unsplash.com/photo-1583195764036-6dc248ac07d9?w=80&h=80&fit=crop&crop=face',
    text: 'Day 7 update: used the Downshift twice this week. Both times it worked. My wife asked what changed. I just smiled.',
    time: '1w',
    likes: 71
  }, {
    name: 'Carlos M.',
    avatar: 'https://images.unsplash.com/photo-1564564321837-a57b7070ac4f?w=80&h=80&fit=crop&crop=face',
    text: 'The pre-encounter script was something I never thought of. Lowered the pressure before anything even started. Brilliant.',
    time: '5d',
    likes: 38
  }, {
    name: 'Daniel P.',
    avatar: 'https://images.unsplash.com/photo-1557862921-37829c790f19?w=80&h=80&fit=crop&crop=face',
    text: '51 years old. New relationship. The anxiety was unbearable. After day 3 of the protocol, I felt like a different person in the bedroom.',
    time: '6d',
    likes: 55,
    replies: [{
      name: 'Tony S.',
      avatar: 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?w=80&h=80&fit=crop&crop=face',
      text: 'Same boat. Day 4 here and already seeing results.',
      time: '5d',
      likes: 7
    }]
  }, {
    name: 'Henry W.',
    avatar: 'https://images.unsplash.com/photo-1542909168-180c6fdbb7e0?w=80&h=80&fit=crop&crop=face',
    text: "I've spent thousands on supplements and doctors. This $6 guide did more for me than all of that combined. It's the mental game that matters.",
    time: '2w',
    likes: 94
  }, {
    name: 'Peter N.',
    avatar: 'https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?w=80&h=80&fit=crop&crop=face',
    text: 'The anti-relapse protocol saved me after a bad night last week. Instead of spiraling for days, I reset in minutes.',
    time: '1w',
    likes: 42
  }, {
    name: 'George A.',
    avatar: 'https://images.unsplash.com/photo-1590086782957-93c06ef21604?w=80&h=80&fit=crop&crop=face',
    text: "54, remarried. Didn't want to disappoint her. This guide gave me tools, not just hope. Real, practical tools.",
    time: '4d',
    likes: 37,
    replies: [{
      name: 'Rick B.',
      avatar: 'https://images.unsplash.com/photo-1599566150163-29194dcabd9c?w=80&h=80&fit=crop&crop=face',
      text: 'The practical approach is what sets this apart. No fluff.',
      time: '3d',
      likes: 14
    }]
  }, {
    name: 'Edward K.',
    avatar: 'https://images.unsplash.com/photo-1480429370612-2cd0cecfe595?w=80&h=80&fit=crop&crop=face',
    text: 'Bought this for my husband. He read it in one sitting. Things have been different since. Thank you.',
    time: '1w',
    likes: 108
  }, {
    name: 'Sam T.',
    avatar: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=80&h=80&fit=crop&crop=face',
    text: "The 14-day checklist keeps me accountable. It's not just theory — it's a real system you follow step by step.",
    time: '3d',
    likes: 31
  }, {
    name: 'Victor R.',
    avatar: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=80&h=80&fit=crop&crop=face',
    text: "I was about to give up on dating entirely. This guide changed my perspective completely. It's not about performance — it's about presence.",
    time: '5d',
    likes: 46
  }];
  const INITIAL_COUNT = 3;
  const visibleComments = showAll ? comments : comments.slice(0, INITIAL_COUNT);
  const hiddenCount = comments.length - INITIAL_COUNT;
  const CommentActions = ({
    time,
    likes
  }: {
    time: string;
    likes: number;
  }) => <div className="flex items-center gap-4 mt-1.5 ml-1" data-id="element-257">
      <span className="text-xs text-[#65676b]" data-id="element-258">{time}</span>
      <button className="text-xs font-semibold text-[#65676b] hover:text-[#050505] transition-colors" data-id="element-259">
        Like
      </button>
      <button className="text-xs font-semibold text-[#65676b] hover:text-[#050505] transition-colors" data-id="element-260">
        Reply
      </button>
      <div className="flex items-center gap-1" data-id="element-261">
        <div className="w-[18px] h-[18px] rounded-full bg-[#1877F2] flex items-center justify-center" data-id="element-262">
          <ThumbsUpIcon className="w-2.5 h-2.5 text-white fill-white" data-id="element-263" />
        </div>
        <span className="text-xs text-[#65676b]" data-id="element-264">{likes}</span>
      </div>
    </div>;
  const SingleComment = ({
    comment,
    isReply = false
  }: {
    comment: Comment;
    isReply?: boolean;
  }) => <div className={`flex gap-2.5 ${isReply ? '' : ''}`} data-id="element-265">
      <img src={comment.avatar} alt={comment.name} className={`${isReply ? 'w-8 h-8' : 'w-10 h-10'} rounded-full object-cover flex-shrink-0 mt-0.5`} data-id="element-266" />
      <div className="flex-1 min-w-0" data-id="element-267">
        <div className="bg-[#f0f2f5] rounded-xl px-3.5 py-2.5 inline-block max-w-full" data-id="element-268">
          <p className="text-[13px] font-semibold text-[#050505] leading-tight" data-id="element-269">
            {comment.name}
          </p>
          <p className="text-[13px] text-[#050505] leading-relaxed mt-0.5" data-id="element-270">
            {comment.text}
          </p>
        </div>
        <CommentActions time={comment.time} likes={comment.likes} data-id="element-271" />
      </div>
    </div>;
  return <section id="reviews" className="py-16 md:py-20 px-4 sm:px-6" data-id="element-272">
      <div className="max-w-2xl mx-auto" data-id="element-273">
        <h2 className="text-2xl md:text-3xl font-bold mb-10 text-center text-text-primary" data-id="element-274">
          What Other Men Are Saying
        </h2>

        <div className="rounded-xl overflow-hidden shadow-xl border border-[#d4d6da]" data-id="element-275">
          {/* Facebook Header */}
          <div className="bg-[#1877F2] px-4 py-3 flex items-center justify-between" data-id="element-276">
            <div className="flex items-center gap-2.5" data-id="element-277">
              <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-278">
                <circle cx="12" cy="12" r="12" fill="white" data-id="element-279" />
                <path d="M16.671 15.469l.547-3.585h-3.44v-2.328c0-.98.48-1.937 2.021-1.937h1.564V4.602s-1.42-.243-2.776-.243c-2.834 0-4.687 1.718-4.687 4.83v2.734H6.72v3.585h3.18V24.24a12.6 12.6 0 003.92 0V15.47h2.85z" fill="#1877F2" data-id="element-280" />
              </svg>
              <span className="text-white text-sm font-semibold" data-id="element-281">
                Comments from our community
              </span>
            </div>
            <span className="text-white/80 text-xs" data-id="element-282">32 comments</span>
          </div>

          {/* Comments Body */}
          <div className="bg-white px-4 py-4 space-y-5 max-h-[500px] overflow-y-auto scrollbar-thin scrollbar-thumb-[#c4c4c4] scrollbar-track-transparent" data-id="element-283">
            {comments.map((comment, index) => <div key={index} data-id="element-284">
                <SingleComment comment={comment} data-id="element-285" />
                {/* Replies */}
                {comment.replies && comment.replies.length > 0 && <div className="ml-12 mt-3 space-y-3" data-id="element-286">
                    {comment.replies.map((reply, rIndex) => <SingleComment key={rIndex} comment={reply} isReply data-id="element-287" />)}
                  </div>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}